import { Component, inject, OnInit } from '@angular/core';
import { ListTableComponent } from '@ppl/ui';
import { PAGE_CONSTANTS } from '../../../shared/constants/page.constants';
import { AllowListAuthStore } from '../../../shared/authorization/allow-list-auth.store';
import { ENROLLMENT_TYPE_BACKEND_MAPPINGS, STATIC_DATA } from '../../../shared/constants/static-data.constants';
import { FileUploadNotificationService } from '../../../services/file-upload-notification.service';
import { FileUploadNotificationData } from '../../../interfaces/file-upload-notification.interface';
import { Router } from '@angular/router';
import { MENU_BASE_URLS } from '../../../shared/constants/url.constants';
import { SectionsService } from '../../../services/sections.service';
import { ReferralDataService } from '../../../services/referral-data.service';
import { UserService } from '../../../services/user.service';
import { AuthorizationUtility } from 'src/app/shared/authorization/auth.utility';

@Component({
  selector: 'ppl-file-upload-notification-list',
  standalone: true,
  imports: [ListTableComponent],
  templateUrl: './file-upload-notification-list.component.html',
  styleUrl: './file-upload-notification-list.component.css'
})
export class FileUploadNotificationListComponent implements OnInit {
  private authUtility = inject(AuthorizationUtility);
  private fileUploadNotificationService = inject(FileUploadNotificationService);
  private sectionService = inject(SectionsService);
  private userService = inject(UserService);
  private referralDataService = inject(ReferralDataService);
  private router = inject(Router)
  private allowListStore = inject(AllowListAuthStore);

  pageId: string = PAGE_CONSTANTS.FILE_UPLOAD_NOTIFICATION_DATA_GRID_PAGE;
  sharedDataKey: string = STATIC_DATA.SHARED_FILE_TRAGE_DATA;
  lazyLoad = true;
  programName!: string;
  isPageRestrictionLoaded = false;
  isReadOnly = false;
  canAcknowledge = false;
  columnsToBeHidden: any = [];
  actionsToBeHidden: any = [];
  buttons = [
    {
      "button_id": "file_upload_notification",
      "button_label": "Acknowledge",
      "buttonAction": "fileUploadNotificationAcknowledge",
      "className": "primary-btn-color"
    }
  ]

  ngOnInit(): void {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.setPageAccess();
  }

  rowClicked(rowDetail: FileUploadNotificationData) {
    const { userType, userId } = rowDetail
    let enrollmentType = userType === 'provider' ? STATIC_DATA.PROVIDER_ENROLLMENT : STATIC_DATA.PARTICIPANT_ENROLLMENT;
    let enrollmentUrl = userType === 'provider' ? MENU_BASE_URLS.PROVIDER_ENROLLMENT : MENU_BASE_URLS.PARTICIPANT_ENROLLMENT;

    this.userService.setSelectedLead(userId.toString());
    this.userService.setLeadEntry(enrollmentType);
    this.userService.setFirstSegment(enrollmentUrl);
    this.sectionService.setFlow(enrollmentType);
    if (userType === 'provider') {
      this.sectionService.setEnrollmentType(JSON.stringify([ENROLLMENT_TYPE_BACKEND_MAPPINGS[rowDetail?.providerType || 'IR']]));
    }
    this.referralDataService.clearReferrralData();
    return this.router.navigate([`/home/${enrollmentUrl}/details`], { state: { navigateToTab: 'documents' } });
  }

  private setPageAccess() {
    const authConfig = this.allowListStore.getConfig();
    if (authConfig && !authConfig.pages[this.pageId]) {
      this.isReadOnly = true;
    }
    this.canAcknowledge = !this.authUtility.isRestrictiedAction(this.pageId, 'file_upload_notification');
    this.isPageRestrictionLoaded = true;
  }
}
